import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./style.module.css";
import { prixFormat } from "../../../utils/PrixFormat";
import useTranslation from "next-translate/useTranslation";
import PROXY_CONFIG from "Config/ProxyConfig";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";

import { actions as UserSpaceActions } from "redux/slices/v2/UserSpace";
import { buildListingUrl } from "components/v2/Listings/ListingsRouterUrlHelper";
import { style } from "@mui/system";
import { set_size } from "utils/getImageToDisplay";
import Image from "next/image";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import { Height } from "@mui/icons-material";
import { buildListingTitle } from "utils/generateFeeds/generateRssFeed";

const index = ({
  key,
  listing,
  onListingPress,
  defaultLiked,
  fromLp,
  searchPayload,
  initialSeachPayload,
  priority,
  NoMaxWidth,
  fromSimilarInside,
  Imageheight = 0,
  noSpecificHeight = false,
  agent,
}: {
  key?: any;
  listing: any;
  onListingPress?: any;
  defaultLiked?: boolean;
  fromLp?: boolean;
  searchPayload?: any;
  initialSeachPayload?: any;
  priority?: boolean;
  NoMaxWidth?: boolean;
  fromSimilarInside?: boolean;
  Imageheight?: number;
  noSpecificHeight?: boolean;
  agent?: boolean;
}) => {
  const [liked, setLiked] = useState(defaultLiked);
  const { t, lang } = useTranslation("annonceAchat");

  const favListings = useSelector(
    ListingreducerSelectors.favoriteListingsSelactor
  );
  const dispatch = useDispatch();

  const mapVsList = useSelector(ListingreducerSelectors.mapVsListSelactor);

  const mapselector = useSelector(ListingreducerSelectors.mapListingSelactor);

  useEffect(() => {
    if (favListings.includes(listing._id)) setLiked(true);
    else setLiked(false);
  }, [favListings]);

  const addDeleteFavourite = (listingId: string, token?: string) => {
    if (favListings.includes(listingId)) {
      api_call_v2(undefined, "post", "deleteFavoris", {
        listingId: listingId,
      })
        .then((res) => {
          dispatch(
            ListingreducerActions.setFavListing({
              favListings: favListings.filter((item) => item !== listingId),
            })
          );
        })
        .catch((err) => { })
        .finally();
    } else {
      api_call_v2(undefined, "post", "addFavoris", {
        listingId: listingId,
      })
        .then((res) => {
          dispatch(
            ListingreducerActions.setFavListing({
              favListings: [...favListings, listingId],
            })
          );
        })
        .catch((err) => { })
        .finally();
    }
  };

  const onFavoriteIconPress = (listingId: string) => {
    const FBIdToken = localStorage.FBIdToken;
    if (FBIdToken) {
      addDeleteFavourite(listingId, FBIdToken);
    } else {
      dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: true }));
    }
  };
  const [isMobile, setIsMobile] = useState(false);
  useLayoutEffect(() => {
    if (window.innerWidth < 990) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  const buildUrlImageWithOperations = (
    url,
    apply_operations = true,
    operations = [
      // { operation: "linear", a: 2, b: 3 },
      // { operation: "gamma", gamma: 2.2, gammaOut: 2.2 },
      // {
      //   operation: "grayscale",
      // },
      {
        operation: "output",
        format: "webp",
      },
    ]
  ) => {
    if (apply_operations) {
      return `https://us-central1-agenz-website-prod.cloudfunctions.net/ext-image-processing-api-handler/process?operations=${encodeURIComponent(
        JSON.stringify([
          { operation: "input", type: "url", url: url },
          ...operations,
        ])
      )}`;
    } else {
      return set_size(url);
    }
  };

  const TransactionOptions = {
    Vente: { label: t("À vendre"), color: "#FF376E" },
    Location: { label: t("À louer"), color: "#FFDC5A" },
    "Projets Neufs": { label: t("Projets Neufs"), color: "#B748D5" },
    Vendu: { label: t("Vendu"), color: "#2291ff" },
  };

  return (
    <div
      className={
        noSpecificHeight
          ? styles.SmallCards
          : `${fromLp ? styles.announceCardNew : styles.annoncesCardListing}`
      }
      style={{ maxWidth: NoMaxWidth ? "none" : "" }}
      key={key}
      onMouseEnter={() => {
        dispatch(
          ListingreducerActions.setMapListing({
            listing: listing,
            coordinates: { latitude: listing.lat, longitude: listing.lng },
          })
        );
        dispatch(ListingreducerActions.setActiveListingId(listing._id));
      }}
    >
      {agent && listing?.vendu ? null : isMobile ? (
        <div
          data-tracking="click"
          data-value="favoris-listing"
          className={`${styles.likedHeart} ${liked ? styles.isFavoriteHeart : ""
            }`}
          onClick={() => {
            onFavoriteIconPress(listing._id);
          }}
        // style={{display: liked ? "block" : ""}}
        >
          {!liked ? (
            <svg
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.0086 2.92508C29.5749 5.40584 29.6731 9.39766 27.2318 11.9936L14.9992 25L2.76814 11.9936C0.326827 9.39761 0.425145 5.40575 2.99143 2.92499C5.85684 0.155079 10.576 0.408187 13.1074 3.46704L15 5.7531L16.891 3.46678C19.4224 0.407927 24.1432 0.155167 27.0086 2.92508Z"
                fill="black"
                fill-opacity="0.4"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.0086 2.92508C29.5749 5.40584 29.6731 9.39766 27.2318 11.9936L14.9992 25L2.76814 11.9936C0.326827 9.39761 0.425145 5.40575 2.99143 2.92499C5.85684 0.155079 10.576 0.408187 13.1074 3.46704L15 5.7531L16.891 3.46678C19.4224 0.407927 24.1432 0.155167 27.0086 2.92508Z"
                fill="#4609F0"
                stroke="#4609F0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </div>
      ) : (
        <div
          data-tracking="click"
          data-value="favoris-listing"
          className={`${styles.likedHeart} ${liked ? styles.isFavoriteHeart : ""
            }`}
          onClick={() => {
            onFavoriteIconPress(listing._id);
          }}
        >
          {!liked ? (
            <svg
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.0064 2.44381C22.9312 4.30438 23.0049 7.29824 21.1739 9.2452L11.9994 19L2.82611 9.24517C0.99512 7.29821 1.06886 4.30431 2.99357 2.44374C5.14263 0.366309 8.68197 0.55614 10.5806 2.85028L12 4.56482L13.4182 2.85009C15.3168 0.555945 18.8574 0.366375 21.0064 2.44381Z"
                fill="black"
                fill-opacity="0.4"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.0064 2.44381C22.9312 4.30438 23.0049 7.29824 21.1739 9.2452L11.9994 19L2.82611 9.24517C0.99512 7.29821 1.06886 4.30431 2.99357 2.44374C5.14263 0.366309 8.68197 0.55614 10.5806 2.85028L12 4.56482L13.4182 2.85009C15.3168 0.555945 18.8574 0.366375 21.0064 2.44381Z"
                fill="#4609F0"
                stroke="#4609F0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </div>
      )}
      <a
        href={buildListingUrl(
          listing,
          lang,
          initialSeachPayload,
          searchPayload,
          mapVsList,
          true
        )}
        onClick={(e) => {
          e.preventDefault();

          window.open(
            buildListingUrl(
              listing,
              lang,
              initialSeachPayload,
              searchPayload,
              mapVsList
            )
          );
        }}
        className={`${styles.cardLink}`}
        target="_blank"
      >
        <div
          // style={noSpecificHeight ? { height: "130px !important" } : {}}
          className={
            noSpecificHeight ? styles.photoSectionNoHeight : styles.photoSection
          }
        // style={{
        //   backgroundImage: ` linear-gradient(180deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.00) 100%), url(${
        //     typeof listing.images == "string"
        //       ? set_size(listing.images)
        //       : listing.images
        //       ? set_size(listing.images[0])
        //       : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
        //   })`,
        //   backgroundPosition: "center",
        //   backgroundSize: "cover",
        //   backgroundRepeat: "no-repeat",
        // }}
        >
          <Image
            unoptimized
            priority={priority ? priority : false}
            alt={buildListingTitle(listing, t, lang)}
            // fill
            width={0}
            height={noSpecificHeight ? 120 : 220}
            style={{
              objectFit: "cover",
              objectPosition: "center",
              width: "100%",
            }}
            src={
              typeof listing.images == "string"
                ? buildUrlImageWithOperations(listing.images, false)
                : listing.images
                  ? buildUrlImageWithOperations(listing.images[0], false)
                  : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
            }
          />
          {listing.virtual_tour ? (
            <>
              <div className={styles.VtourCon}>
                <div className={`${styles.Vtour}`}>
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Vector"
                      d="M12.9903 10.773C12.9887 10.6326 12.9893 10.4907 12.9903 10.3456V4.72845C12.9671 4.52397 12.8735 4.37573 12.6652 4.25221C10.9075 3.21456 9.15516 2.1685 7.40664 1.11719C7.15399 0.965278 6.94678 0.957919 6.68818 1.11351C4.92397 2.17481 3.15489 3.22928 1.37823 4.27113C1.14884 4.4057 1.03686 4.55919 1.00818 4.78417C1.00223 4.82832 0.999527 4.87511 1.00007 4.92505C1.01089 6.07308 1.00007 7.22058 1.00818 8.36862C1.00872 8.46113 1.00926 8.55417 1.01035 8.64669C1.01089 8.6777 1.00981 8.70609 1.00818 8.73342V11.4432C1.0493 11.593 1.14938 11.7018 1.31655 11.7975C3.08618 12.8157 4.85148 13.8412 6.61352 14.8726C6.91 15.0455 7.16914 15.0418 7.46236 14.8652C9.18005 13.8312 10.901 12.801 12.6289 11.7828C12.8453 11.655 12.959 11.5084 12.9903 11.3023C12.999 11.2466 13.0017 11.1872 12.999 11.1225C12.9941 11.0064 12.9914 10.8902 12.9903 10.773ZM6.62543 13.7566C6.62543 13.8055 6.61352 13.8549 6.60379 13.9274C6.51452 13.8817 6.44365 13.8491 6.37656 13.8102C4.91369 12.9576 3.45027 12.106 1.99173 11.2461C1.90354 11.194 1.80508 11.0694 1.80454 10.978C1.79372 9.17024 1.79697 7.36251 1.79751 5.55478C1.79751 5.52324 1.80508 5.4917 1.81266 5.43178C1.89705 5.47488 1.95927 5.50379 2.01824 5.53796C3.48869 6.39531 4.96022 7.25107 6.42526 8.11735C6.51885 8.17255 6.61731 8.31132 6.61785 8.41172C6.62975 10.1932 6.62651 11.9751 6.62543 13.7566ZM6.88132 7.46449C5.3611 6.56825 3.83547 5.68146 2.31146 4.79153C2.28225 4.77418 2.2552 4.75263 2.18541 4.7048C3.0007 4.22067 3.78083 3.75809 4.56096 3.29499C5.32702 2.83977 6.09091 2.38087 6.86185 1.93406C6.94245 1.8878 7.09394 1.86678 7.16535 1.90883C8.69206 2.81138 10.2123 3.72497 11.7336 4.63699C11.7482 4.6454 11.7585 4.66169 11.7834 4.68692C11.7282 4.7274 11.6779 4.7705 11.6211 4.80467C10.1533 5.68462 8.68449 6.56246 7.21728 7.44346C7.10313 7.51232 7.0182 7.54439 6.88132 7.46449ZM11.9494 11.2624C10.5455 12.0913 9.14867 12.9308 7.74909 13.7661C7.66686 13.8155 7.58138 13.8596 7.46561 13.9238C7.45641 13.8228 7.44451 13.7498 7.44451 13.6772C7.44342 11.931 7.44072 10.1853 7.451 8.43958C7.45154 8.33392 7.52999 8.18464 7.61979 8.12997C9.08104 7.24319 10.5504 6.36797 12.0182 5.49118C12.0544 5.4691 12.0928 5.45175 12.1799 5.40655C12.1799 5.53533 12.1794 5.6126 12.1799 5.6904C12.1815 7.40982 12.1799 9.12977 12.1907 10.8492C12.1918 11.051 12.1242 11.1593 11.9494 11.2624Z"
                      fill="#00B4FF"
                      stroke="#00B4FF"
                    />
                  </svg>
                  {t("Visite 3D")}
                </div>
              </div>
            </>
          ) : null}
          {agent && listing?.vendu ? (
            <div className={styles.label}>
              <div className={`${styles.venduMark}`}>{t("Vendu")}</div>
            </div>
          ) : (
            <div className={styles.label}>
              {
                // listing?.exclusivite &&
                listing?.vendu && listing.transaction_type === "Vente" ? (
                  <div className={`${styles.venduMark}`}>{t("Vendu")}</div>
                ) : (
                  <div className={`${styles.dateCreationList}`}>
                    {listing[`date_${lang}`]
                      ? listing[`date_${lang}`]
                      : listing?.date
                        ? listing?.date.split("T")[0]
                        : ""}{" "}
                  </div>
                )
              }
              {listing?.exclusivite ? (
                // && !listing?.vendu
                <div className={styles.labelAnnonceVerified}>
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.37559 9.00011L7.79226 10.4168L10.6256 7.58344M5.5502 3.82718C6.05845 3.78662 6.54096 3.58676 6.92903 3.25605C7.83462 2.48431 9.16657 2.48431 10.0722 3.25605C10.4602 3.58676 10.9427 3.78662 11.451 3.82718C12.637 3.92183 13.5789 4.86366 13.6735 6.04971C13.7141 6.55797 13.9139 7.04047 14.2446 7.42854C15.0164 8.33414 15.0164 9.66608 14.2446 10.5717C13.9139 10.9597 13.7141 11.4422 13.6735 11.9505C13.5789 13.1366 12.637 14.0784 11.451 14.173C10.9427 14.2136 10.4602 14.4135 10.0722 14.7442C9.16657 15.5159 7.83462 15.5159 6.92903 14.7442C6.54096 14.4135 6.05845 14.2136 5.5502 14.173C4.36414 14.0784 3.42232 13.1366 3.32767 11.9505C3.28711 11.4422 3.08725 10.9597 2.75654 10.5717C1.9848 9.66608 1.9848 8.33414 2.75654 7.42854C3.08725 7.04047 3.28711 6.55797 3.32767 6.04971C3.42232 4.86366 4.36414 3.92183 5.5502 3.82718Z"
                      stroke="white"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{t("Exclu Agenz")}</span>
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div className={styles.contentSection}>
          {// agent &&
            listing?.vendu ? // || (searchPayload?.vendu != undefined && searchPayload?.vendu)
              null : (
                <div className={styles.priceContainer}>
                  {listing.price_cut ? (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                      <div className={styles.price}>
                        <b className={styles.nouveau} style={{ color: "#FF376E" }}>
                          {prixFormat(Math.floor(listing.prix))}
                        </b>
                        <div className={styles.mad} style={{ color: "#FF376E" }}>
                          {t("DH")}
                          {listing?.transaction_type === "Location"
                            ? ` / ${t("mois")}`
                            : ""}
                        </div>
                      </div>
                      <div className={styles.oldPrice}>
                        <b className={styles.nouveau} style={{ color: "#757E83" }}>
                          {prixFormat(Math.floor(listing.old_price))}{" "}
                          <s style={{ color: "#757E83" }}>
                            {t("DH")}
                            {listing?.transaction_type === "Location"
                              ? ` / ${t("mois")}`
                              : ""}
                          </s>
                        </b>
                        {/* <div className={styles.mad} style={{ color: "#757E83" }}>
                  </div> */}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className={styles.price}>
                        <b className={styles.nouveau}>
                          {prixFormat(Math.floor(listing.prix))}
                        </b>
                        <div className={styles.mad}>
                          {t("DH")}
                          {listing?.transaction_type === "Location"
                            ? ` / ${t("mois")}`
                            : ""}
                        </div>
                      </div>
                    </>
                  )}
                  {!fromLp && listing.transaction_type === "Projets Neufs" ? (
                    <div className={styles.projetNeuf}>{t("Projet Neuf")}</div>
                  ) : null}
                </div>
              )}
          {listing?.vendu ? (
            // searchPayload.vendu
            <span className={styles.subtitleNew}>
              <i
                className={"fas fa-circle"}
                style={{
                  color: TransactionOptions[listing.transaction_type]
                    ? TransactionOptions[
                      listing.vendu ? "Vendu" : listing.transaction_type
                    ].color
                    : "red",
                  fontSize: "14px",
                }}
              />
              <text>
                {t(listing.type)}{" "}
                {listing.vendu
                  ? listing.date_fr
                    ? `${listing.transaction_type == "Location"
                      ? t("loué")
                      : t("vendu")
                    } ${lang == "ar" ? listing.date_ar : lang == "en" ? listing.date_en : listing.date_fr}`
                    : ""
                  : listing.transaction_type == t("Location")
                    ? t("à louer")
                    : t("à vendre")}{" "}
              </text>
            </span>
          ) : null}
          <div className={styles.content}>
            <div
              className={`${styles.info} ${!fromLp ? styles.infoFromLp : ""}`}
            >
              {listing.typologie > 0 ? (
                <>
                  <div>
                    <div className={styles.rooms}>
                      <div className={styles.nouveau}>{listing.typologie}</div>
                      <div className={styles.typeBien}>
                        {listing?.typologie == 1
                          ? t(" Ch")
                          : listing?.typologie < 11
                            ? t(" Ch ")
                            : t("Ch")}
                      </div>
                    </div>
                  </div>
                  <div className={styles.bullet2} />
                </>
              ) : null}
              {listing.sdb > 0 ? (
                <>
                  <div>
                    {" "}
                    <div className={styles.rooms}>
                      <div className={styles.nouveau}>
                        {listing.sdb ? listing.sdb : 0}
                      </div>
                      <div className={styles.typeBien}>
                        {listing.sdb == 1
                          ? t(" sdb")
                          : listing.sdb < 11
                            ? t("sdb ")
                            : t("sdb")}
                      </div>
                    </div>
                  </div>
                  <div className={styles.bullet2} />
                </>
              ) : null}
              {listing.surface > 0 ? (
                <>
                  <div className={styles.rooms}>
                    <div className={styles.nouveau}>{listing.surface}</div>
                    <div className={styles.typeBien}>{t("m²")}</div>
                  </div>
                  {fromSimilarInside ? null : (
                    <div className={styles.bullet2} />
                  )}
                </>
              ) : null}
              {fromLp ? (
                <div>
                  <div className={styles.typeAnnonces}>
                    <div className={styles.typeBien}>
                      {" "}
                      {`${t(listing.type)}`}
                    </div>
                  </div>
                </div>
              ) : null}
              {!listing?.vendu && !fromLp && !fromSimilarInside ? (
                <div>
                  <div
                    className={`${styles.type} ${!fromLp ? styles.typeAnnonces : ""
                      }`}
                  >
                    <div className={styles.typeBien}>
                      {" "}
                      {`${t(listing.type)}`}{" "}
                      {!fromLp
                        ? listing.transaction_type === "Location"
                          ? t("à louer")
                          : t("à vendre")
                        : null}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className={styles.address}>
              <div className={styles.casablancaLes1}>
                <p className={styles.locationAdress}>
                  {listing?.commune == "Bouskoura" ||
                    listing?.commune == "Dar Bouazza"
                    ? t(listing?.commune?.trim())
                    : t(listing?.province?.trim())}{" "}
                  {listing?.quartier ? "-" : ""} {t(listing?.quartier?.trim())}
                </p>
              </div>
            </div>
            <div
              className={styles.AgenceDiv}
              style={{ display: noSpecificHeight ? "none" : "block" }}
            >
              <div
                className={`${styles.agencyName} ${!fromLp ? styles.agencyNameNoLp : ""
                  }`}
              >
                {listing.agence?.nameEntreprise ||
                  typeof listing.agence == "string"
                  ? fromLp
                    ? t("proposée par") + " : "
                    : t("Annonce par") + " : "
                  : null}
                {listing.agence?.nameEntreprise
                  ? listing.agence.nameEntreprise
                  : typeof listing.agence == "string"
                    ? listing.agence
                    : t("Annonce par le propriétaire")}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default index;
